import PropTypes from 'prop-types';
import {useMemo, useState, useEffect} from 'react';
import {useDebouncedEffect} from '@ozgene/gp5.hooks.use-debounced-effect';
import TextField from '@material-ui/core/TextField';
import {getStringChangeHandler} from '@ozgene/gp5.utils.data-functions';
import {Grid} from '@material-ui/core';
import {validateUniqueScheduleName} from 'Schedule/service/ScheduleService';

export default function ScheduleEditor(props) {
  const {entity, onPropertyChange, onValidityChange} = props;
  const {id = '', title = ''} = entity;
  const [isValidating, setIsValidating] = useState(false);
  const [titleErrorText, setTitleErrorText] = useState('');
  const handleChangeTitle = getStringChangeHandler('title', onPropertyChange);
  const isTitleInvalid = useMemo(
    () => !title || !!titleErrorText,
    [title, titleErrorText],
  );

  useDebouncedEffect(
    () => {
      const validateName = async () => {
        setTitleErrorText(await validateUniqueScheduleName(title, id));
        setIsValidating(false);
      };

      return validateName();
    },
    [title],
    500,
  );
  useEffect(() => setIsValidating(true), [title]);
  useEffect(
    () => onValidityChange(!isValidating && !isTitleInvalid),
    [isValidating, isTitleInvalid, onValidityChange],
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Name"
          type="text"
          value={title}
          onChange={handleChangeTitle}
          error={isTitleInvalid}
          helperText={titleErrorText}
          inputProps={{maxLength: 50}}
        />
      </Grid>
    </Grid>
  );
}

ScheduleEditor.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  onPropertyChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func.isRequired,
};
